function formatTimestamp(timestampStr: string) {
  const dt: any = new Date(timestampStr);
  const now: any = new Date();

  // Helper to zero out time for date comparison
  function stripTime(date: any) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  const dtDate = stripTime(dt);
  const nowDate = stripTime(now);

  // Date formatting
  let dateStr;
  if (dtDate.getTime() === nowDate.getTime()) {
    dateStr = "Today";
  } else if (dtDate.getTime() === nowDate.getTime() - 24 * 60 * 60 * 1000) {
    dateStr = "Yesterday";
  } else {
    // Format as dd/mm/yyyy
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yyyy = dt.getFullYear();
    dateStr = `${dd}/${mm}/${yyyy}`;
  }

  // Time ago formatting
  const diffMs = now - dt;
  const diffSec = Math.floor(diffMs / 1000);
  let timeStr;
  if (diffSec < 60) {
    timeStr = `${diffSec} sec ago`;
  } else if (diffSec < 3600) {
    const mins = Math.floor(diffSec / 60);
    timeStr = `${mins} min${mins > 1 ? "s" : ""} ago`;
  } else if (diffSec < 86400) {
    const hrs = Math.floor(diffSec / 3600);
    timeStr = `${hrs} hr${hrs > 1 ? "s" : ""} ago`;
  } else {
    const days = Math.floor(diffSec / 86400);
    timeStr = `${days} day${days > 1 ? "s" : ""} ago`;
  }

  return { date: dateStr, time: timeStr };
}

export class PreviousConversationListEntity {
  listData: PreviousConversationCardEntity[];
  constructor(obj: any) {
    this.listData = obj.map(
      (item: any) => new PreviousConversationCardEntity(item)
    );
  }
}

export class PreviousConversationCardEntity {
  date: string;
  time: string;
  title: string;
  subtitle: string;
  convId: string;

  constructor(obj: any) {
    this.title = obj?.title;
    this.subtitle = obj?.latest_message;
    this.date = formatTimestamp(obj?.created_at).date;
    this.time = formatTimestamp(obj?.created_at).time;
    this.convId = obj?.session_id;
  }
}
